export const fullOrderLeathers = [
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'グレー', value: 'gray', color: '#A7A9AB' },
  { label: 'Rオレンジ', value: 'rOrange', color: '#FF362E' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'キャメル', value: 'camel', color: '#D7CEA5' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラウン', value: 'brown', color: '#1a0c0a' },
  { label: 'レモン', value: 'lemon', color: '#D9D943' },
  { label: 'イエロー', value: 'yellow', color: '#E8C84B' },
  { label: 'ピンク', value: 'pink', color: '#E179AA' },
  { label: 'パープル', value: 'purple', color: '#7B5BA0' },
  { label: 'グリーン', value: 'green', color: '#49914D' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: '空色', value: 'sky', color: '#88C7E2' }
]

export const semiOrderLeathers = [
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'Rオレンジ', value: 'rOrange', color: '#FF362E' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'キャメル', value: 'camel', color: '#D7CEA5' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラウン', value: 'brown', color: '#1a0c0a' },
  { label: 'レモン', value: 'lemon', color: '#D9D943' },
  { label: 'イエロー', value: 'yellow', color: '#E8C84B' }
]

export const edgeColors = [
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'Rオレンジ', value: 'rOrange', color: '#FF362E' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'イエロー', value: 'yellow', color: '#E8C84B' },
  { label: 'レモン', value: 'lemon', color: '#D9D943' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラウン', value: 'brown', color: '#1a0c0a' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: 'グリーン', value: 'green', color: '#49914D' },
  { label: 'ピンク', value: 'pink', color: '#E179AA' },
  { label: 'パープル', value: 'purple', color: '#7B5BA0' },
  { label: 'グレー', value: 'gray', color: '#A7A9AB' },
  { label: '空色', value: 'sky', color: '#88C7E2' },
  { label: 'キャメル', value: 'camel', color: '#D7CEA5' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'ゴールド', value: 'gold', color: '#FFD700' },
  { label: 'シルバー', value: 'silver', color: '#C0C0C0' }
]

export const hamidashiObjs = [
  { label: '切りハミ(ホワイト)', value: 'kirihamiWhite', color: '#fff', canSelectSemiOrder: true },
  { label: '玉ハミ(ブラック)', value: 'black', color: '#1E1E1E', canSelectSemiOrder: false },
  { label: '玉ハミ(Rオレンジ)', value: 'rOrange', color: '#FF362E', canSelectSemiOrder: false },
  { label: '玉ハミ(オレンジ)', value: 'orange', color: '#FF6C23', canSelectSemiOrder: false },
  { label: '玉ハミ(イエロー)', value: 'yellow', color: '#E8C84B', canSelectSemiOrder: false },
  { label: '玉ハミ(レモン)', value: 'lemon', color: '#D9D943', canSelectSemiOrder: false },
  { label: '玉ハミ(コルク)', value: 'cork', color: '#CE7220', canSelectSemiOrder: false },
  { label: '玉ハミ(チョコ)', value: 'chocolate', color: '#652821', canSelectSemiOrder: false },
  { label: '玉ハミ(ブラウン)', value: 'brown', color: '#1a0c0a', canSelectSemiOrder: false },
  { label: '玉ハミ(ネイビー)', value: 'navy', color: '#363C53', canSelectSemiOrder: false },
  { label: '玉ハミ(ブルー)', value: 'blue', color: '#193B85', canSelectSemiOrder: false },
  { label: '玉ハミ(ピンク)', value: 'pink', color: '#E179AA', canSelectSemiOrder: false },
  { label: '玉ハミ(パープル)', value: 'purple', color: '#7B5BA0', canSelectSemiOrder: false },
  { label: '玉ハミ(グレー)', value: 'gray', color: '#A7A9AB', canSelectSemiOrder: false },
  { label: '玉ハミ(空色)', value: 'sky', color: '#88C7E2', canSelectSemiOrder: false },
  { label: '玉ハミ(ホワイト)', value: 'white', color: '#fff', canSelectSemiOrder: false },
  { label: '玉ハミ(グリーン)', value: 'green', color: '#49914D', canSelectSemiOrder: false },
  { label: '玉ハミ(キャメル)', value: 'camel', color: '#D7CEA5', canSelectSemiOrder: false },
  { label: '玉ハミ(ゴールド)', value: 'gold', color: '#FFD700', canSelectSemiOrder: false },
  { label: '玉ハミ(シルバー)', value: 'silver', color: '#C0C0C0', canSelectSemiOrder: false }
]

export const laceObjs = [
  { label: 'ブラック', value: 'black', color: '#282925' },
  { label: '中白ブラック', value: 'material#1D1D1D', color: '#282925' },
  { label: 'Rオレンジ', value: 'rOrange', color: '#FF362E' },
  { label: '中白Rオレンジ', value: 'materialROrange', color: '#FF362E' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'イエロー', value: 'yellow', color: '#E8C84B' },
  { label: 'レモン', value: 'lemon', color: '#D9D943' },
  { label: 'コルクタン', value: 'cork', color: '#CE7220' },
  { label: 'チョコブラウン', value: 'chocolate', color: '#652821' },
  { label: 'レッド', value: 'red', color: '#CB1527' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: 'スカイブルー', value: 'skyBlue', color: '#42bdff' },
  { label: 'パープル', value: 'purple', color: '#7B5BA0' },
  { label: 'グレー', value: 'gray', color: '#A7A9AB' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'キャメル', value: 'camel', color: '#D7CEA5' }
]

export const moutonObjs = [
  { label: 'ホワイト', value: 'white', color: '#fff', imageUrl: '/ragDeLion/colorSettings/mouton/white.jpg' },
  { label: 'ブラック', value: 'black', color: '#1E1E1E', imageUrl: '/ragDeLion/colorSettings/mouton/black.jpg' }
]

export const stitchObjs = [
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'レッド', value: 'red', color: '#CB1527' },
  { label: 'イエロー', value: 'yellow', color: '#E8C84B' },
  { label: 'サックスブルー', value: 'saxBlue', color: '#53B7ED' },
  { label: '空色', value: 'sky', color: '#88CEF2' },
  { label: 'ピンク', value: 'pink', color: '#E179AA' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'パープル', value: 'purple', color: '#6a1ca3' },
  { label: 'グリーン', value: 'green', color: '#009c09' },
  { label: 'シルバー', value: 'silver', color: '#A7A9AB' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'シャンパンゴールド', value: 'champagneGold', color: '#E4D3B8' }
]

export const ragLabelObjs = [
  { label: 'R-1 ゴールドxブラック', value: 'r1', imageUrl: '/ragDeLion/labels/r1.jpg' },
  { label: 'R-2 シルバーxブラック', value: 'r2', imageUrl: '/ragDeLion/labels/r2.jpg' },
  { label: 'R-3 蛍光イエローxブラック', value: 'r3', imageUrl: '/ragDeLion/labels/r3.jpg' },
  { label: 'R-4 オレンジxブルー', value: 'r4', imageUrl: '/ragDeLion/labels/r4.jpg' },
  { label: 'R-5 ブラックxレッド', value: 'r5', imageUrl: '/ragDeLion/labels/r5.jpg' },
  { label: 'R-6 ゴールドx空色', value: 'r6', imageUrl: '/ragDeLion/labels/r6.jpg' },
  { label: 'R-7 ゴールドxブルー', value: 'r7', imageUrl: '/ragDeLion/labels/r7.jpg' },
  { label: 'R-8 ゴールドxパープル', value: 'r8', imageUrl: '/ragDeLion/labels/r8.jpg' },
  { label: 'R-9 ゴールドxエンジ', value: 'r9', imageUrl: '/ragDeLion/labels/r9.jpg' },
  { label: 'R-10 ゴールドxグリーン', value: 'r10', imageUrl: '/ragDeLion/labels/r10.jpg' },
  { label: 'R-11 ネイビーxゴールド', value: 'r11', imageUrl: '/ragDeLion/labels/r11.jpg' },
  { label: 'R-12 Dブルーxシルバー', value: 'r12', imageUrl: '/ragDeLion/labels/r12.jpg' },
  { label: 'R-13 ピンクxシルバー', value: 'r13', imageUrl: '/ragDeLion/labels/r13.jpg' },
  { label: 'R-14 ブラックxキャメル', value: 'r14', imageUrl: '/ragDeLion/labels/r14.jpg' },
  { label: 'R-15 ブラウンxキャメル', value: 'r15', imageUrl: '/ragDeLion/labels/r15.jpg' },
  { label: 'R-16 サックスブルーxキャメル', value: 'r16', imageUrl: '/ragDeLion/labels/r16.jpg' },
  { label: 'R-17 Dブルーxキャメル', value: 'r17', imageUrl: '/ragDeLion/labels/r17.jpg' },
  { label: 'R-18 パープルxキャメル', value: 'r18', imageUrl: '/ragDeLion/labels/r18.jpg' },
  { label: 'R-19 ピンクxキャメル', value: 'r19', imageUrl: '/ragDeLion/labels/r19.jpg' },
  { label: 'R-20 レッドxキャメル', value: 'r20', imageUrl: '/ragDeLion/labels/r20.jpg' },
  { label: 'R-21 ブラックxブラック', value: 'r21', imageUrl: '/ragDeLion/labels/r21.jpg' },
  { label: 'R-22 ゴールドxホワイト', value: 'r22', imageUrl: '/ragDeLion/labels/r22.jpg' },
  { label: 'R-23 ブラックxホワイト', value: 'r23', imageUrl: '/ragDeLion/labels/r23.jpg' },
  { label: 'R-24 ホワイトxホワイト', value: 'r24', imageUrl: '/ragDeLion/labels/r24.jpg' },
  { label: 'R-25 サックスブルーxホワイト', value: 'r25', imageUrl: '/ragDeLion/labels/r25.jpg' },
  { label: 'R-26 Dブルーxホワイト', value: 'r26', imageUrl: '/ragDeLion/labels/r26.jpg' },
  { label: 'R-27 パープルxホワイト', value: 'r27', imageUrl: '/ragDeLion/labels/r27.jpg' },
  { label: 'R-28 オレンジxホワイト', value: 'r28', imageUrl: '/ragDeLion/labels/r28.jpg' },
  { label: 'R-29 ピンクxホワイト', value: 'r29', imageUrl: '/ragDeLion/labels/r29.jpg' },
  { label: 'R-30 グリーンxホワイト', value: 'r30', imageUrl: '/ragDeLion/labels/r30.jpg' }
]

export const ragLabelColorObjs = [
  { value: 'r1', outOfEdge: '#363739', core: '#D4B15C' },
  { value: 'r2', outOfEdge: '#363739', core: '#ACB0AC' },
  { value: 'r3', outOfEdge: '#222324', core: '#BBC95B' },
  { value: 'r4', outOfEdge: '#2C4396', core: '#E16935' },
  { value: 'r5', outOfEdge: '#AF342E', core: '#3F403F' },
  { value: 'r6', outOfEdge: '#80ABD8', core: '#D4B15C' },
  { value: 'r7', outOfEdge: '#2A4C8F', core: '#D4B15C' },
  { value: 'r8', outOfEdge: '#563C77', core: '#D4B15C' },
  { value: 'r9', outOfEdge: '#683C3B', core: '#D4B15C' },
  { value: 'r10', outOfEdge: '#5B7A5A', core: '#D4B15C' },
  { value: 'r11', outOfEdge: '#C89E3E', core: '#272E59' },
  { value: 'r12', outOfEdge: '#E5DFCE', core: '#2E4483' },
  { value: 'r13', outOfEdge: '#E5DFCE', core: '#ff3377' },
  { value: 'r14', outOfEdge: '#AE9D74', core: '#363739' },
  { value: 'r15', outOfEdge: '#AE9D74', core: '#322520' },
  { value: 'r16', outOfEdge: '#AE9D74', core: '#6ce6e1' },
  { value: 'r17', outOfEdge: '#AE9D74', core: '#2E4483' },
  { value: 'r18', outOfEdge: '#AE9D74', core: '#563C77' },
  { value: 'r19', outOfEdge: '#AE9D74', core: '#ff3377' },
  { value: 'r20', outOfEdge: '#AE9D74', core: '#AF342E' },
  { value: 'r21', outOfEdge: '#363739', core: '#3F403F' },
  { value: 'r22', outOfEdge: '#E2E2DF', core: '#C4AC5C' },
  { value: 'r23', outOfEdge: '#E2E2DF', core: '#3A3A3A' },
  { value: 'r24', outOfEdge: '#D1DFEA', core: '#8697B2' },
  { value: 'r25', outOfEdge: '#E2E2DF', core: '#6ce6e1' },
  { value: 'r26', outOfEdge: '#D1DFEA', core: '#323172' },
  { value: 'r27', outOfEdge: '#E2E2DF', core: '#563C77' },
  { value: 'r28', outOfEdge: '#D1DFEA', core: '#e65f39' },
  { value: 'r29', outOfEdge: '#D1DFEA', core: '#ff3377' },
  { value: 'r30', outOfEdge: '#D1DFEA', core: '#3B8547' }
]

const commonPartsObjs = [
  // 共通
  { label: '全体', value: 'all', order: 0 },
  { label: '捕球面', value: 'catchFace', order: 12 },
  { label: '平裏', value: 'linings', order: 13 },
  { label: '親指掛け紐', value: 'thumbHook', order: 14 },
  { label: '小指掛け紐', value: 'littleHook', order: 15 },
  { label: 'ウェブ', value: 'web', order: 16 },
  { label: 'ウェブ2', value: 'web2', order: 17 },
  { label: 'ヘリ革', value: 'edge', order: 18 },
  { label: '指カバー/指当て', value: 'indexCover', order: 23 }
]
const firstMittCommonPartsObjs = [
  // 共通
  { label: '全体', value: 'all', order: 0 },
  { label: '捕球面', value: 'catchFace', order: 12 },
  { label: '平裏', value: 'linings', order: 13 },
  { label: '親指掛け紐', value: 'thumbHook', order: 14 },
  { label: '小指掛け紐', value: 'littleHook', order: 15 },
  { label: 'ウェブ', value: 'web', order: 16 },
  { label: 'ヘリ革', value: 'edge', order: 18 },
  { label: '指カバー/指当て', value: 'indexCover', order: 23 }
]

const commonNoMoutonPartsObjs = [
  // 共通
  { label: '全体', value: 'all', order: 0 },
  { label: 'ベルト', value: 'listBelt', order: 11 },
  { label: '捕球面', value: 'catchFace', order: 12 },
  { label: '平裏', value: 'linings', order: 13 },
  { label: '親指掛け紐', value: 'thumbHook', order: 14 },
  { label: '小指掛け紐', value: 'littleHook', order: 15 },
  { label: 'ウェブ', value: 'web', order: 16 },
  { label: 'ヘリ革', value: 'edge', order: 18 },
  { label: '指カバー/指当て', value: 'indexCover', order: 23 }
]

const backBeltStyleGloveObjs = [
  { label: '親指1', value: 'thumbOut', order: 1 },
  { label: '親指2', value: 'thumbWeb', order: 2 },
  { label: '人差指3', value: 'indexWeb', order: 3 },
  { label: '人差指4', value: 'indexMiddle', order: 4 },
  { label: '中指5', value: 'middleIndex', order: 5 },
  { label: '中指6', value: 'middleRing', order: 6 },
  { label: '薬指7', value: 'ringMiddle', order: 7 },
  { label: '薬指8', value: 'ringLittle', order: 8 },
  { label: '小指9', value: 'littleRing', order: 9 },
  { label: '小指10', value: 'littleOut', order: 10 },
  { label: 'ベルト', value: 'listBelt', order: 11 },
  { label: '投手デザイン', value: 'pitcherDesign', order: 25 }
]

const backCrownBackGloveObjs = [
  { label: '親指1', value: 'thumbOut', order: 1 },
  { label: '親指2', value: 'thumbWeb', order: 2 },
  { label: '人差指3', value: 'indexWeb', order: 3 },
  { label: '人差指4・中指5', value: 'indexLeftMiddleRight', order: 4 },
  { label: '中指6・薬指7', value: 'middleLeftRingRight', order: 6 },
  { label: '薬指8・小指9', value: 'ringLeftLittleRight', order: 8 },
  { label: '小指10', value: 'littleOut', order: 10 },
  { label: 'ベルト', value: 'listBelt', order: 11 },
  { label: '投手デザイン', value: 'pitcherDesign', order: 25 }
]

// 中指一体仕様: FALSE
const backFirstBackGloveObjs = [
  { label: '親指1', value: 'thumbOut', order: 1 },
  { label: '親指2・人差指3・人差指4・中指5', value: 'thumbIndexMiddleRight', order: 2 },
  { label: '中指6・薬指7', value: 'middleLeftRingRight', order: 6 },
  { label: '薬指8・小指9', value: 'ringLeftLittleRight', order: 8 },
  { label: '小指10', value: 'littleOut', order: 10 },
  { label: 'ベルト', value: 'listBelt', order: 11 },
  { label: '投手デザイン', value: 'pitcherDesign', order: 25 }
]

// 中指一体仕様: TRUE
const backFirstBackGloveMiddleIntegratedObjs = [
  { label: '親指1', value: 'thumbOut', order: 1 },
  { label: '親指2・人差指3・人差指4・中指5・中指6・薬指7', value: 'thumbIndexMiddleRingRight', order: 2 },
  { label: '薬指8・小指9', value: 'ringLeftLittleRight', order: 8 },
  { label: '小指10', value: 'littleOut', order: 10 },
  { label: 'ベルト', value: 'listBelt', order: 11 },
  { label: '投手デザイン', value: 'pitcherDesign', order: 25 }
]

const backGloveForUBackObjs = [
  { label: '親指1', value: 'thumbOut', order: 1 },
  { label: '親指2・人差指3', value: 'thumbWebAndIndexWeb', order: 2 },
  { label: '人差指4', value: 'indexMiddle', order: 4 },
  { label: '中指5', value: 'middleIndex', order: 5 },
  { label: '中指6', value: 'middleRing', order: 6 },
  { label: '薬指7', value: 'ringMiddle', order: 7 },
  { label: '薬指8', value: 'ringLittle', order: 8 },
  { label: '小指9', value: 'littleRing', order: 9 },
  { label: '小指10', value: 'littleOut', order: 10 },
  { label: 'ベルト', value: 'listBelt', order: 11 }
]

export const catcherMittBackPartsObjs = [
  { label: '親指・人差指・中指右', value: 'thumbIndexMiddleRight', order: 5 },
  { label: '中指左・薬指・小指', value: 'middleLeftRingLittle', order: 7 },
  { label: '中指左・薬指', value: 'middleLeftRing', order: 6 },
  { label: '小指', value: 'littleOut', order: 7 },
  { label: '土台', value: 'fingerStand', order: 4 },
  { label: '指だし', value: 'indexFingerTipOut', order: 8 },
  { label: 'ベルト', value: 'listBelt', order: 11 }
]

const backOfRegularBackStyleCatcherMittObjs = [
  { label: '親指・人差指・中指右', value: 'thumbIndexMiddleRight', order: 5 },
  { label: '中指左・薬指', value: 'middleLeftRing', order: 6 },
  { label: '小指', value: 'littleOut', order: 7 },
  { label: '土台', value: 'fingerStand', order: 4 },
  { label: '指だし', value: 'indexFingerTipOut', order: 8 }
]
const backOfBeltBackStyleCatcherMittObjs = [
  { label: '土台', value: 'fingerStand', order: 4 },
  { label: '親指・人差指・中指右', value: 'thumbIndexMiddleRight', order: 5 },
  { label: '中指左・薬指・小指', value: 'middleLeftRingLittle', order: 7 }
]

const backFirstMittObjs = [
  { label: 'ウェブ下', value: 'underWeb', order: 4 },
  { label: '親指', value: 'thumb', order: 5 },
  { label: 'ブーメラン', value: 'boomerang', order: 6 }
]

// 背面
export const gloveBeltBackPartsObjs = [...commonPartsObjs, ...backBeltStyleGloveObjs]
export const gloveCrownBackPartsObjs = [...commonPartsObjs, ...backCrownBackGloveObjs]
export const gloveFirstBackPartsObjs = [...commonPartsObjs, ...backFirstBackGloveObjs]
export const gloveFirstBackMiddleIntegratedPartsObjs = [...commonPartsObjs, ...backFirstBackGloveMiddleIntegratedObjs]
export const infielderBackPartsForUBackObjs = [...commonPartsObjs, ...backGloveForUBackObjs]
export const catcherMittBackofBeltBackStylePartsObjs = [...commonPartsObjs, ...backOfBeltBackStyleCatcherMittObjs]
export const catcherMittBackofRegularBackStylePartsObjs = [...commonNoMoutonPartsObjs, ...backOfRegularBackStyleCatcherMittObjs]
export const firstMittBackPartsObjs = [...firstMittCommonPartsObjs, ...backFirstMittObjs, { label: 'ベルト', value: 'listBelt', order: 11 }]

// 捕球面＿グローブ
export const gloveCatchFacePartsObjs = [...commonPartsObjs]
// 捕球面＿キャッチャーミット
export const catcherMittCatchFaceObjs = [
  ...commonPartsObjs,
  { label: '親指マチ', value: 'thumbMachi', order: 2 },
  { label: '小指マチ', value: 'littleMachi', order: 3 },
  { label: 'ハミダシ(捕球面)', value: 'hamidashiOfCatchFace', order: 4 }
]

export const partsObjs = [
  ...gloveBeltBackPartsObjs,
  ...gloveCrownBackPartsObjs,
  ...gloveFirstBackPartsObjs,
  ...gloveFirstBackMiddleIntegratedPartsObjs,
  ...infielderBackPartsForUBackObjs,
  ...firstMittBackPartsObjs,
  ...gloveCatchFacePartsObjs,
  ...catcherMittCatchFaceObjs,
  { label: '薬指リング', value: 'loopOfRingFingerColor', order: 24 },
  { label: '投手デザイン', value: 'pitcherDesign', order: 25 }
]

export const partsOfCatcherMittObjs = [...catcherMittBackPartsObjs, ...catcherMittCatchFaceObjs]

export const fullOrderDispatchColors = {
  stitch: stitchObjs,
  linings: fullOrderLeathers,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  hamidashiOfCatchFace: hamidashiObjs,
  edge: edgeColors,
  all: fullOrderLeathers,
  catchFace: fullOrderLeathers,
  web: fullOrderLeathers,
  web2: fullOrderLeathers,
  thumbHook: fullOrderLeathers,
  littleHook: fullOrderLeathers,
  indexCover: fullOrderLeathers,
  thumbOut: fullOrderLeathers,
  thumbWeb: fullOrderLeathers,
  thumbWebAndIndexWeb: fullOrderLeathers,
  thumbIndexMiddleRight: fullOrderLeathers,
  thumbIndexMiddleRingRight: fullOrderLeathers,
  thumbIndexMiddle: fullOrderLeathers,
  indexWeb: fullOrderLeathers,
  indexMiddle: fullOrderLeathers,
  indexLeftMiddleRight: fullOrderLeathers,
  middleIndex: fullOrderLeathers,
  middleRing: fullOrderLeathers,
  middleLeftRing: fullOrderLeathers,
  middleLeftRingRight: fullOrderLeathers,
  middleLeftRingLittle: fullOrderLeathers,
  ringMiddle: fullOrderLeathers,
  ringLittle: fullOrderLeathers,
  ringLeftLittleRight: fullOrderLeathers,
  loopOfRingFingerColor: fullOrderLeathers,
  littleRing: fullOrderLeathers,
  littleOut: fullOrderLeathers,
  listBelt: fullOrderLeathers,
  thumb: fullOrderLeathers,
  boomerang: fullOrderLeathers,
  underWeb: fullOrderLeathers,
  thumbMachi: fullOrderLeathers,
  littleMachi: fullOrderLeathers,
  indexAndMiddle: fullOrderLeathers,
  fingerStand: fullOrderLeathers,
  indexFingerTipOut: fullOrderLeathers,
  pitcherDesign: fullOrderLeathers,
  mouton: moutonObjs,
  ragLabel: ragLabelObjs
}

export const semiOrderDispatchColors = {
  stitch: stitchObjs,
  linings: semiOrderLeathers,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  hamidashiOfCatchFace: hamidashiObjs,
  edge: edgeColors,
  all: semiOrderLeathers,
  catchFace: semiOrderLeathers,
  web: semiOrderLeathers,
  web2: semiOrderLeathers,
  thumbHook: semiOrderLeathers,
  littleHook: semiOrderLeathers,
  indexCover: semiOrderLeathers,
  thumbOut: semiOrderLeathers,
  thumbWeb: semiOrderLeathers,
  thumbWebAndIndexWeb: semiOrderLeathers,
  thumbIndexMiddleRight: semiOrderLeathers,
  thumbIndexMiddleRingRight: semiOrderLeathers,
  thumbIndexMiddle: semiOrderLeathers,
  indexWeb: semiOrderLeathers,
  indexMiddle: semiOrderLeathers,
  indexLeftMiddleRight: semiOrderLeathers,
  middleIndex: semiOrderLeathers,
  middleRing: semiOrderLeathers,
  middleLeftRing: semiOrderLeathers,
  middleLeftRingRight: semiOrderLeathers,
  middleLeftRingLittle: semiOrderLeathers,
  ringMiddle: semiOrderLeathers,
  ringLittle: semiOrderLeathers,
  ringLeftLittleRight: semiOrderLeathers,
  loopOfRingFingerColor: semiOrderLeathers,
  littleRing: semiOrderLeathers,
  littleOut: semiOrderLeathers,
  listBelt: semiOrderLeathers,
  thumb: semiOrderLeathers,
  boomerang: semiOrderLeathers,
  underWeb: semiOrderLeathers,
  thumbMachi: semiOrderLeathers,
  littleMachi: semiOrderLeathers,
  indexAndMiddle: semiOrderLeathers,
  fingerStand: semiOrderLeathers,
  indexFingerTipOut: semiOrderLeathers,
  pitcherDesign: semiOrderLeathers,
  mouton: moutonObjs,
  ragLabel: ragLabelObjs
}

// export const PARTS_BUTTON_OPTION = 'ragdelion-parts-button-option'
export const LEATHER_COLOR_BUTTON_OPTION = 'ragdelion-leather-color-button-option'
export const LACE_COLOR_BUTTON_OPTION = 'ragdelion-lace-color-button-option'
export const EDGE_COLOR_BUTTON_OPTION = 'ragdelion-edge-color-button-option'
export const STITCH_COLOR_BUTTON_OPTION = 'ragdelion-stitch-color-button-option'
export const HAMIDASHI_COLOR_BUTTON_OPTION = 'ragdelion-hamidashi-color-button-option'
export const MOUTON_BUTTON_OPTION = 'ragdelion-mouton-button-option'
export const LABEL_BUTTON_OPTION = 'ragdelion-label-button-option'
export const DIRECT_EMBROIDERY_LABEL_BUTTON_OPTION = 'ragdelion-direct-embroidery-label-button-option'
